export default __webpack_public_path__ + "dcf9c7594549439caec68c63e92ac2b3.png";